/** Storage says this when the object is already gone, which removal wants. */
export function isObjectMissing(cause: unknown): boolean {
  return (
    typeof cause === "object" &&
    cause !== null &&
    "code" in cause &&
    (cause as { code?: unknown }).code === "storage/object-not-found"
  );
}
